export function getEditorLanguage(content: string, contentType: string): string {
  if (contentType === 'json') return 'json';
  if (contentType === 'xml') return 'xml';
  if (content.includes('{#script')) return 'blazemeter-script';
  return 'text';
}
